import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  adobeClickEventAnalyticsMocks,
  ANALYTICS_EVENTS,
  EVENT_CLICK_TYPE,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../common/cookie-helper';
import { QueryStringHelper } from '../common/query-string-helper';
import { ApplicationConfig } from '../config/config';
import { UrlUtil } from '../config/urlutil';
import { ICorporatePartner } from '../corporate-partner/corporate-partner.interface';
import { getCorporatePartner } from '../corporate-partner/corporate-partner.method';
import { NgcGlobalNav } from '../header/global-nav.component';
import { SwitchingAccountService } from '../header/switching-account/switching-account.service';
import { ContentDarkSite } from '../model/content/contentDarkSite.model';
import {
  ContentFooter,
  ContentSearch
} from '../model/content/contentfooter.model';
import { ContentFooterPopularTopic } from '../model/content/contentfooterpopulartopic.model';
import { AdobeDataLayerService } from '../services/adobe-data-layer/adobe-data-layer';
import { CommonService } from '../services/common.service';
import { ContentHeaderFooterService } from '../services/content/contentheaderfooter.service';

declare let picturefillBackground: any;

@Component({
  selector: 'ngc-global-footer',
  templateUrl: './global-footer.component.html',
  providers: [CookieHelper]
})
// tslint:disable-next-line:component-class-suffix
export class NgcGlobalFooter implements OnInit, OnDestroy, AfterViewChecked {
  public darkSiteThemeContent: ContentDarkSite;
  isDarkSiteEnabled = true;
  public contentFooter: ContentFooter;
  additionalInfo = '';
  public popularTopic: ContentFooterPopularTopic;
  public contentSearch: ContentSearch;
  public prefCookieValue: any;
  public hasCorpCookie: any;
  public cookieAcceptanceValue: any;
  public showCookieTerms = false;
  public actionUrl: string;
  public defaultFooter = true;
  public disableBusinessHomePage = true;
  public partnerId = 'default';
  public corpPartner: ICorporatePartner;
  public deepLinkCacheKey;
  isEnabled = 'true';
  contentServiceHeaderFooterSubscribe: Subscription;
  isLightFooterEnable = false;
  isBAUOrStaticPg = false;
  restrictProfileSelector = false;
  enableSearch = true;
  @Input() globalNav: NgcGlobalNav;
  @Input() pageName = '';
  @Input() hideSearchButton = false;
  contentLoaded = false;
  private unsubscribe: Subject<void> = new Subject();
  private storeModalRef: BsModalRef;
  private disableCLS: boolean;
  businessUser = false;
  showNewProfileSelector: boolean;
  darkSiteLevel = '';

  constructor(
    private contentService: ContentHeaderFooterService,
    private cdf: ChangeDetectorRef,
    private commonService: CommonService,
    private urlUtil: UrlUtil,
    private cookieHelper: CookieHelper,
    private appconfig: ApplicationConfig,
    public switchingAccountService: SwitchingAccountService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _route: ActivatedRoute,
    private queryStringHelper: QueryStringHelper,
    private loggingService: LoggingService,
    private adobeDataLayer: AdobeDataLayerService
  ) {}

  ngOnInit() {
    this.deepLinkCacheKey = this.getQueryParams('cacheKeySuffix');
    this.corpPartner = getCorporatePartner(this.partnerId);
    this.restrictProfileSelector = this.commonService.hidingProfileSelector();
    this.setHipmunkCookieForFooter(this.restrictProfileSelector);
    if (this.appconfig.get('APP_TRIM_FOOTER') === 'false') {
      this.defaultFooter = false;
    } else {
      this.defaultFooter = true;
    }
    if (this.appconfig.get('APP_SITESEARCH_TURN_OFF') === 'true') {
      this.enableSearch = false;
    } else {
      this.enableSearch = true;
    }
    if (
      this.appconfig !== undefined &&
      this.appconfig.get('APP_BAU_OR_STATIC_PG') &&
      this.appconfig.get('APP_BAU_OR_STATIC_PG') === 'true'
    ) {
      this.isBAUOrStaticPg = true;
    }
    this.isLightFooterEnable = this.commonService.checkLightHeaderFooter();
    this.disableCLS =
      this.appconfig.get('APP_DISABLE_CLS2') &&
      this.appconfig.get('APP_DISABLE_CLS2') === 'true'
        ? true
        : false;
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            this.contentServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    if (data) {
                      const countryCode = this.cookieHelper.getCountryCode();
                      this.showNewProfileSelector =
                        !!data?.header?.enableNewProfileSelector;
                      this.contentFooter = data.footer;
                      if (this.showNewProfileSelector) {
                        const account =
                          this.switchingAccountService.getAccountCookie(
                            'account'
                          );
                        if (account && account.length) {
                          const parseAccount = JSON.parse(account);
                          this.businessUser = parseAccount['isBusiness'];
                        }
                      }
                      if (
                        data.header.disableBusinessHomePage &&
                        data.header.disableBusinessHomePage !== null &&
                        data.header.disableBusinessHomePage !== undefined &&
                        data.header.disableBusinessHomePage !== ''
                      ) {
                        this.disableBusinessHomePage =
                          data.header.disableBusinessHomePage === 'true'
                            ? true
                            : false;
                      } else {
                        this.disableBusinessHomePage = true;
                      }
                      if (this.disableBusinessHomePage) {
                        this.partnerId = 'default';
                      } else {
                        this.prefCookieValue =
                          this.cookieHelper.getCookies('prefUI');
                        // checks if corp cookie exists or not
                        this.hasCorpCookie =
                          this.cookieHelper.getCookies('corp');
                        if (this.hasCorpCookie) {
                          this.partnerId = 'edp';
                          this.switchingAccountService.setIntranetlink(true);
                        }
                      }
                      this.corpPartner = this.commonService.getCorpPartner(
                        this.partnerId,
                        this.corpPartner,
                        this.deepLinkCacheKey
                      );
                      if (this.disableCLS) {
                        this.contentFooter.countryLanguage = null;
                      }
                      this.popularTopic = data.footer.populartopics;
                      this.contentSearch = data.footer.search;
                      if (data.darkSite) {
                        this.darkSiteThemeContent = data.darkSite;
                        if (
                          this.darkSiteThemeContent.isEnabled === this.isEnabled
                        ) {
                          if (
                            this.darkSiteThemeContent.level ===
                            this.appconfig.get('APP_DARKSITE_LEVEL_0')
                          ) {
                            this.isDarkSiteEnabled = false;
                          } else {
                            this.isDarkSiteEnabled = true;
                          }
                          this.darkSiteLevel =
                            this.darkSiteThemeContent.enableBlackTheme ===
                            'true'
                              ? this.darkSiteThemeContent.level
                              : '';
                        }
                      }
                      // find the additional info based on country code
                      if (
                        data.footer.additionalInfo &&
                        data.footer.additionalInfo.length > 0
                      ) {
                        data.footer.additionalInfo.forEach((element) => {
                          if (element?.countryCode === countryCode) {
                            this.additionalInfo = element.info;
                          }
                        });
                      }
                      this.cdf.detectChanges();
                      this.contentLoaded = true;
                    }
                  },
                  (err) => {
                    if (this.appconfig.onBrowser) {
                      this.loggingService.log('Caught Error: ' + err);
                    }
                  }
                );
          }
        }
      });
    this.switchingAccountService.corporatePartnerChange.subscribe(
      (corpPartner: ICorporatePartner) => {
        this.corpPartner = corpPartner;
        this.corpPartner = this.commonService.getCorpPartner(
          this.partnerId,
          this.corpPartner,
          this.deepLinkCacheKey
        );
        this.cdf.detectChanges();
      }
    );
  }

  ngAfterViewChecked(): void {
    if (this.appconfig.onBrowser && this.contentLoaded) {
      const componentRef = this; // Added to correctly point component reference instead of function reference
      try {
        if (typeof picturefillBackground === 'function') {
          picturefillBackground();
        }
        setTimeout(function () {
          if (componentRef.switchingAccountService.businessAccount) {
            if (componentRef.switchingAccountService.corpPartner) {
              componentRef.corpPartner =
                componentRef.switchingAccountService.corpPartner;
            }
          }
        }, 300);
      } catch (error) {
        this.loggingService.log('Caught Error: ' + error);
      }
      this.contentLoaded = false;
    }
  }

  setTrackingObject(itemText: string, e?: any): void {
    if (!e || !e.target) return;

    const url = e.target.getAttribute('href') || '';
    const isUrl = url && (url.startsWith('/') || url.startsWith('http'));
    const cleanUrl = this.adobeDataLayer.removeCountryLanguageFromUrl(url);

    const clickedText = e.target.innerText || e.target.textContent || itemText;
    const data = {
      ...adobeClickEventAnalyticsMocks,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: ANALYTICS_EVENTS.CLICK,
      click: {
        name: clickedText,
        type: isUrl ? EVENT_CLICK_TYPE.LINK : EVENT_CLICK_TYPE.BUTTON,
        page_section: `footer:popular topics:${itemText.toLowerCase()}`,
        action: cleanUrl
      }
    };

    this.adobeDataLayer.setUserDataInAnalytics(data);
  }

  setHipmunkCookieForFooter(pageRestricted: boolean) {
    const hipmunkCookie =
      this.cookieHelper.getCookieValue('isHipmunk') !== null
        ? this.cookieHelper.getCookieValue('isHipmunk')
        : false;
    const hipmunkPaxCount = this.urlUtil.getURLParam('paxCount', null);
    const setPartnerToPersonal =
      this.cookieHelper.getCookieValue('restrictToPersonal');
    if (this.pageName !== '' && this.pageName === 'confirmation') {
      // this.pageNameFromPropertiesForFooter) {
      this.cookieHelper.setCookieName('isHipmunk', '', 0, false);
      this.partnerId = this.setPartnerIdName('default'); // need to work
    } else if (hipmunkCookie) {
      this.setBusinessFlagForHipmunk();
      this.partnerId = pageRestricted
        ? 'hipmunk'
        : this.setPartnerIdName('default');
    } else {
      if (
        this.urlUtil.getURLParam('hipmunk-id', null) !== null &&
        hipmunkPaxCount !== null
      ) {
        // set hipmunk cookie only if pax count is 1
        if (hipmunkPaxCount === '1' || hipmunkPaxCount === 1) {
          this.cookieHelper.setCookieName('isHipmunk', true, 0, true);
          this.setBusinessFlagForHipmunk();
          this.partnerId = 'hipmunk';
        } else {
          this.cookieHelper.setCookieName('isHipmunk', '', 0, false);
          this.partnerId = this.setPartnerIdName('default'); // need to work
        }
      }
    }
    this.hasCorpCookie = this.cookieHelper.getCookies('corp');
    if (this.hasCorpCookie) {
      this.partnerId = 'edp';
    }
    this.corpPartner = getCorporatePartner(this.partnerId);
  }

  setBusinessFlagForHipmunk() {
    this.corpPartner = getCorporatePartner('hipmunk');
    this.switchingAccountService.toggleAccount(false, true);
  }

  setPartnerIdName(partnerIdName: string): string {
    const setPartnerToPersonal =
      this.cookieHelper.getCookieValue('restrictToPersonal');
    if (setPartnerToPersonal && setPartnerToPersonal.length) {
      return setPartnerToPersonal;
    } else {
      return partnerIdName;
    }
    // return partnerIdName;
  }

  openWidget(widget: string) {
    if (this.globalNav) {
      this.globalNav.openWidgetFromOutsideLink(widget);
    }
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }

  saveModalServiceRef(openedModalRef) {
    this.globalNav.storeModalRef = openedModalRef;
  }

  getQueryParams(queryParamName: string) {
    let queryParamValue;
    if (
      this._route.snapshot.queryParams &&
      this._route.snapshot.queryParams[queryParamName] !== undefined &&
      this._route.snapshot.queryParams[queryParamName] !== null
    ) {
      queryParamValue = this._route.snapshot.queryParams[queryParamName];
    } else {
      queryParamValue = undefined;
    }
    if (!queryParamValue) {
      queryParamValue =
        this.queryStringHelper.getParameterByName(queryParamName);
    }
    return queryParamValue;
  }
}
